import { Component } from '@angular/core';

@Component({
  selector: 'app-rmu-layout',
  templateUrl: './rmu-layout.component.html',
  styleUrls: ['./rmu-layout.component.scss']
})
export class RmuLayoutComponent {

}
